import React from "react";
import {Card, CardBody} from "reactstrap";
import {useStatsRansomwareTrackerEventsByCountries} from "../../../../queries/Stats";
import LoadingSpinner from "../../../../shared/components/LoadingSpinner";
import SimpleMapsWithData from "../../../../shared/components/maps/EasyVectorMap/SimpleMapsWithData";
import {useHistory} from "react-router-dom";
import paths from "../../../../config/paths";
import allCountries from './../../../../shared/components/maps/EasyVectorMap/sample-data.json';
import {getCountryNameOrCodeShort} from "../../../../shared/helpers/country-data";

const _ = require('lodash');


const RansomwareTargetVictimStats = () => {
  const history = useHistory();
  const { data, isIdle, isLoading, isError, error } = useStatsRansomwareTrackerEventsByCountries();
  if (isError) {
    console.log(error);
  }

  const targetedRansomwareCountries = isError ? [] :
    allCountries.map((country) => {
      const match = _.find(data?.data, (c) => c.name.includes(country.id));
      if (!match) {
        return {id: country.name, value: 0}
      } else {
        return {id: match.name, value: match.value}
      }
    });

  return (
    <Card>
      <CardBody>
        <div className="card__title">
          <h4 className={'bold-text d-inline'}>Most Targeted Countries By Ransomware</h4>
        </div>
        {
          isIdle || isLoading ? <LoadingSpinner /> :
            <SimpleMapsWithData
              data={targetedRansomwareCountries}
              height={'45vh'}
              isError={isError}
              valueLabel={'events'}
              onCountryClick={(ev) => {
                history.push(`${paths.ransomwareTrackerEventsPath}?victim_country=${getCountryNameOrCodeShort(ev.target.dataItem.dataContext.id)}`)
              }}
              divName={'ransomware-most-targeted'}
            />
        }
      </CardBody>
    </Card>
  )
}

RansomwareTargetVictimStats.propTypes = {
}

export default RansomwareTargetVictimStats;
